import { IAddress } from '@components/FormAddressFields/types';

export const getAddressInformation = (addressInfo?: IAddress) => {
  if (!addressInfo) return '';
  const { addressLine1, addressLine2, administrativeArea, locality, postalCode } = addressInfo;

  return `${[addressLine1, addressLine2, locality].filter(Boolean).join(', ')}, ${administrativeArea} ${postalCode}`;
};
